import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './Header.module.scss';
import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import PerformanceToggle from '../../components/Performance/PerformanceToggle';

const cx = classNames.bind(styles);
const { Header } = Layout;

const HeaderLayout = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Cấu hình menu bằng tiếng Việt
    const menuItems = [
        {
            key: '/',
            label: 'Trang chủ',
        },
        {
            key: '/about',
            label: 'Giới thiệu',
        },
        {
            key: '/skill',
            label: 'Kỹ năng',
        },
        {
            key: '/experience',
            label: 'Kinh nghiệm',
        },
        {
            key: '/projects',
            label: 'Dự án',
        },
    ];

    // Xác định item nào đang active
    const selectedKeys =
        menuItems.find((item) => item.key === currentPath || (currentPath.startsWith(item.key) && item.key !== '/'))
            ?.key || '/';

    // Theo dõi thay đổi kích thước màn hình - Chỉ có desktop và mobile
    useEffect(() => {
        const handleResize = () => {
            // Mobile: <= 46.25em (740px)
            // Desktop: > 46.25em (740px)
            setIsMobile(window.innerWidth <= 906);
            if (window.innerWidth > 906) {
                setMobileMenuOpen(false);
            }
        };

        handleResize(); // Kiểm tra khi component được render
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Đóng menu khi thay đổi trang
    useEffect(() => {
        setMobileMenuOpen(false);
    }, [location.pathname]);

    // Xử lý đóng menu khi chọn một liên kết
    const handleMobileMenuItemClick = () => {
        setMobileMenuOpen(false);
    };

    // Xử lý đóng/mở menu mobile
    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <Header className={cx('header')}>
            <div className={cx('header-container')}>
                <div className={cx('logo')}>
                    <Link to="/">
                        <div className={cx('logo-icon')}>
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                    fill="#1677ff"
                                />
                                <path d="M15 9.5L11.5 9.5L9.5 14.5L13 14.5L15 9.5Z" fill="white" />
                            </svg>
                        </div>
                        <span className={cx('logo-text')}>Portfolio</span>
                    </Link>
                </div>

                {/* Menu desktop - Chỉ hiển thị khi không phải là mobile */}
                {!isMobile && (
                    <div className={cx('menu-section')}>
                        <Menu mode="horizontal" selectedKeys={[selectedKeys]} className={cx('menu')}>
                            {menuItems.map((item) => (
                                <Menu.Item key={item.key}>
                                    <Link to={item.key}>{item.label}</Link>
                                </Menu.Item>
                            ))}
                        </Menu>
                    </div>
                )}

                <div className={cx('right-section')}>
                    {/* Performance Toggle */}
                    <PerformanceToggle />

                    {/* Contact button - hiển thị trên tất cả kích thước màn hình */}
                    <Link to="/contact" className={cx('contact-btn')}>
                        Liên hệ
                    </Link>

                    {/* Mobile menu button - Chỉ hiển thị khi là mobile */}
                    {isMobile && (
                        <button
                            className={cx('mobile-menu-button', { active: mobileMenuOpen })}
                            onClick={toggleMobileMenu}
                            aria-label="Menu"
                        >
                            <span className={cx('icon-bar')}></span>
                            <span className={cx('icon-bar')}></span>
                            <span className={cx('icon-bar')}></span>
                        </button>
                    )}
                </div>
            </div>

            {/* Mobile menu container - Chỉ hiển thị khi là mobile */}
            {isMobile && (
                <div className={cx('mobile-menu-container', { active: mobileMenuOpen })}>
                    {menuItems.map((item, index) => (
                        <div
                            key={item.key}
                            className={cx('mobile-menu-item')}
                            style={{ '--index': index }}
                        >
                            <Link
                                to={item.key}
                                className={currentPath === item.key ? cx('active') : ''}
                                onClick={handleMobileMenuItemClick}
                            >
                                {item.label}
                            </Link>
                        </div>
                    ))}
                </div>
            )}
        </Header>
    );
};

export default HeaderLayout;